import { CircleCompletedSvg } from "@/components/svg"
import { Circle1Active } from "@/components/svg/circle-1-active"
import { Circle2 } from "@/components/svg/circle-2"
import { Circle2Active } from "@/components/svg/circle-2-active"

enum recoverySteps {
  contacts = "CONTACTS",
  otp = "OTP",
  change = "CHANGE",
  result = "RESULT",
}

type RecoveryStepsKey = recoverySteps

const stepPasswordRecovery = {
  [recoverySteps.contacts]: {
    icon: Circle1Active,
    activeIcon: Circle1Active,
    completedIcon: CircleCompletedSvg,
    status: "active",
  },
  [recoverySteps.change]: {
    icon: Circle2,
    activeIcon: Circle2Active,
    completedIcon: CircleCompletedSvg,
    status: "inactive",
  },
}

const otpRefreshed = "otpRefreshed"
const passwordRecoveryStatus = "recPwdStatus"
const recoveryPasswordStep = "recPwdStep"
const recoveryPasswordParam = "recuperaPassword"

const cleanupParams = [
  recoveryPasswordStep,
  otpRefreshed,
  recoveryPasswordParam,
  passwordRecoveryStatus,
]

export {
  cleanupParams,
  otpRefreshed,
  passwordRecoveryStatus,
  recoveryPasswordParam,
  recoveryPasswordStep,
  recoverySteps,
  stepPasswordRecovery,
}
export type { RecoveryStepsKey }
